import { View } from 'react-native'
import { styled } from '~/core/styled'

export const OnSaleContainer = styled(View, theme => {
  return {
    base: {
      position: 'absolute',
      top: 0,
      right: 0,
    },
  }
})
